/* eslint-disable react-hooks/exhaustive-deps */
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { getApiCaller } from "../../libs/apiCaller";

const EditFees = ({ isOpen, onClose, feesData, handleFetchDashboard }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = feesData.reduce((acc, fee) => {
      acc[fee.title.replace(/\s+/g, " ")] = fee.amount;
      return acc;
    }, {});
    formik.setValues(fetchData);
  }, [feesData]);

  const validationSchema = Yup.object(
    feesData.reduce((acc, fee) => {
      const fieldName = fee.title.replace(/\s+/g, " ");
      let validation = Yup.number()
        .required("This field is required")
        .positive("Value must be positive");

      // If fee.is_percentage is true, set max to 100
      if (fee.is_percentage) {
        validation = validation.max(100, "Value cannot exceed 100");
      }

      acc[fieldName] = validation;
      return acc;
    }, {})
  );

  // Initialize Formik
  const formik = useFormik({
    initialValues: feesData.reduce((acc, fee) => {
      acc[fee.title.replace(/\s+/g, " ")] = fee.amount;
      return acc;
    }, {}),
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      const queryParams = new URLSearchParams(values).toString();
      try {
        const resposne = await getApiCaller(`edit_fees?${queryParams}`);
        if (resposne.data?.status) {
          toast.success(resposne.data?.response_message);
          onClose();
          formik.resetForm();
          handleFetchDashboard && handleFetchDashboard();
        }
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75 transition-opacity" />

      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-0 sm:p-4">
          <DialogPanel className="relative w-full transform overflow-hidden bg-white text-left shadow-xl transition-all rounded-lg max-w-[95vw] sm:max-w-md md:max-w-lg">
            <div className="bg-[#21140E0F] px-3 pb-6 pt-2 sm:px-6">
              <div className="flex justify-between items-center">
                <DialogTitle className="text-base sm:text-xl font-bold text-[#284184]">
                  Edit Fees
                </DialogTitle>
                <button
                  onClick={() => {
                    onClose();
                    formik.resetForm();
                  }}
                  className="text-[#1C2024] p-2 rounded-full transition-colors"
                >
                  <span className="text-4xl leading-none">&times;</span>
                </button>
              </div>

              <form onSubmit={formik.handleSubmit}>
                <div
                  className="h-[70vh] overflow-auto [&::-webkit-scrollbar]:w-2
  [&::-webkit-scrollbar-track]:bg-gray-100
  [&::-webkit-scrollbar-thumb]:bg-gray-300 p-2"
                >
                  {feesData.map((fee, index) => {
                    const fieldName = fee.title.replace(/\s+/g, " ");
                    return (
                      <div key={index} className="mb-4">
                        <label
                          for="input-group-1"
                          class="block mb-2 text-sm font-medium text-gray-900 "
                        >
                          {fee.title}
                        </label>
                        <div class="relative">
                          <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                            {fee.is_percentage ? "%" : "$"}
                          </div>
                          <input
                            type="number"
                            {...formik.getFieldProps(fieldName)}
                            min="0"
                            step="1"
                            className={`pl-7 w-full rounded-md border py-2 px-3 text-sm sm:text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow ${
                              formik.errors[fieldName] &&
                              formik.touched[fieldName]
                                ? "border-red-500"
                                : "border-gray-300"
                            }`}
                          />
                        </div>
                        {formik.errors[fieldName] &&
                          formik.touched[fieldName] && (
                            <div className="text-sm text-red-500 mt-1">
                              {formik.errors[fieldName]}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>

                <div className="flex gap-3 mt-6">
                  <button
                    type="button"
                    onClick={() => {
                      onClose();
                      formik.resetForm();
                    }}
                    className="w-full rounded-md border font-bold border-[#F04438] bg-white px-3 sm:px-4 py-2 text-sm text-[#F04438]"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="w-full rounded-md border font-bold border-transparent bg-[#284184] px-3 sm:px-4 py-2 text-sm text-white"
                    disabled={isLoading}
                  >
                    {isLoading ? "Loading..." : "Save"}
                  </button>
                </div>
              </form>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default EditFees;
